import PropTypes from "prop-types";
import React from "react";

import { inputPropTypes } from "@swa-ui/core";
import { TextFormField } from "@swa-ui/form";
import i18n from "@swa-ui/locale";

import {
  STREET_ADDRESS_MAX_LENGTH,
  STREET_ADDRESS_SCHEMA_FIELD_NAME,
} from "./StreetAddressFormField.schema";

/**
 * StreetAddressFormField facilitates the input of a street address.
 */

export const StreetAddressFormField = (props) => {
  const {
    componentProps,
    disabled,
    label = i18n("StreetAddressFormField__LABEL"),
    name = STREET_ADDRESS_SCHEMA_FIELD_NAME,
  } = props;

  return <TextFormField {...getTextFormFieldProps()} />;

  function getTextFormFieldProps() {
    return {
      componentProps: {
        "aria-label": i18n("StreetAddressFormField__ARIA"),
        maxLength: STREET_ADDRESS_MAX_LENGTH,
        ...componentProps,
      },
      disabled,
      label,
      name,
    };
  }
};

export const streetAddressFormFieldPropTypes = {
  /** Component props for input component. */
  componentProps: PropTypes.shape(inputPropTypes),

  /** Indicates whether the field is disabled. */
  disabled: PropTypes.bool,

  /** Content above the form field, used to identify the form field. */
  label: PropTypes.string,

  /** Form field name used in schema validation and service call payload. */
  name: PropTypes.string,
};

StreetAddressFormField.propTypes = streetAddressFormFieldPropTypes;
